// const authentication = require('react-azure-adb2c').default;
// const authentication = require('react-azure-adb2c');
import authentication from 'react-azure-adb2c';







export const send = (values) => {
 

        let url = process.env.REACT_APP_API_LINE_URL+`/api/LineSends/`;
        // let url = `https://localhost:44385/api/LineSends/`;
       
        const token = authentication.getAccessToken();

            return  fetch(url, {
            method: 'post',
            body: JSON.stringify(values),

            headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

        }).then(res => res.json())
        .then(payload => ({ payload }))
            .catch(error => ({ error }));

};



